function sectionRedering() {
  fetch("?section_id=cart-drawer")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".cart__content-wrap", cart__html);
      $(".cart__content-wrap").replaceWith(render__html);

      var render__html = $(".cart__top-text p", cart__html);
      $(".cart__top-text p").replaceWith(render__html);

      var render__html = $(".cart__announcement", cart__html);
      $(".cart__announcement").replaceWith(render__html);

      cartSlider();
    });

  // header 
  // header section 
  fetch("?section_id=header")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".header__right-cart span", cart__html);
      $(".header__right-cart span").replaceWith(render__html);
    });

}


// cart slider 

function cartSlider() {
  $('.cart__product-add-items').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true
  });

}

cartSlider()


// match variant and update variant id and variant image 
// $(document).ready(function () { 
function selectedVarint() {
  var slectedId = $(".select__variant").val();
  var url = new URL(window.location.href);
  url.searchParams.set("variant", slectedId);
  window.history.replaceState({}, "", url);
}

//   // update variant image 
function updateVariantImage(variant_featured_img) {
  if (variant_featured_img) {
    $(".product-hero__big-item").each(function () {
      let img__src = $(this).find("img").attr("src");
      if (variant_featured_img === img__src) {
        let index = $(this).closest(".product-hero__big-item").attr("data-slick-index");
        $('.product-hero__big-items').slick('slickGoTo', index);
      }
    })
  }
}

//   // match variant

// function matchVariant() {
//   var updateValue = "";
//   $(".product-hero__color-item input[type='radio']:checked").each(function () {

//     updateValue += (updateValue ? " / " : "") + $(this).val();
//   })

//   var isMatchFound = false;
//   $(".select__variant option").each(function () {

//     var optionValue = $(this).text().trim();

//     if (updateValue.toLowerCase() == optionValue.toLowerCase()) {
//       isMatchFound = true;
//       $(this).prop("selected", true);
//       var variant_pirce = $(this).attr("data-variant-price").replace(/<\/?[^>]+(>|$)/g, "").trim();

//       // console.log(variant_pirce);

//       var variant__available = $(this).attr("data-variant-available");
//       let variant_name = optionValue.split(" / ");


//       $(".product-hero__color-name em").each(function (index) {
//         $(this).text(variant_name[index])
//       });
//       var variant_featured_img = $(this).attr("data-variant-featured-img");
//       // console.log(optionValue); 

//       // call update variant image function 
//       updateVariantImage(variant_featured_img);
//       if (variant__available == 'false') {
//         $(".product-hero__add-pro").addClass("disabled");
//         $(this).addClass("disabled");
//         $(".product-hero__add-pro").text("Out Of Stock");
//       } else {
//         $(".product-hero__add-pro").removeClass("disabled");
//         $(this).removeClass("disabled");
//         $(".product-hero__add-pro").text("ADD to cart");
//       }
//       $(".product-hero__guide-price span").text(variant_pirce);
//     } 
//     return true;

//   });
//   if (!isMatchFound) {

//     let variant_name = updateValue.trim().split(" / ");

//     $(".product-hero__color-name em").each(function (index) {
//       $(this).text(variant_name[index]);
//     });
//     // $(".product-hero__add-pro").addClass("disabled");




//   }

// }

// $(".product-hero__color-item input[type='radio']").change(function () {
//   matchVariant();
//   selectedVarint();
// })

// $(document).ready(function () {
//   matchVariant();
// });





function matchVariant() {
  
  var updateValue = "";
  $(".product-hero__color-item input[type='radio']:checked").each(function () {

    updateValue += (updateValue ? " / " : "") + $(this).val();
  })

  var isMatchFound = false;
  $(".select__variant option").each(function () {

    var optionValue = $(this).text().trim();

    if (updateValue.toLowerCase() == optionValue.toLowerCase()) {
      isMatchFound = true;
      $(this).prop("selected", true);
      var variant_pirce = $(this).attr("data-variant-price").replace(/<\/?[^>]+(>|$)/g, "").trim();

      // console.log(variant_pirce);

      var variant__available = $(this).attr("data-variant-available");
      let variant_name = optionValue.split(" / ");


      $(".product-hero__color-name em").each(function (index) {
        $(this).text(variant_name[index])
      });
      var variant_featured_img = $(this).attr("data-variant-featured-img");
      // console.log(optionValue); 

      // call update variant image function 
      updateVariantImage(variant_featured_img);
      // Get current locale and texts
      const locale = window.localizedTexts?.locale || 'default';
      const outOfStockText = window.localizedTexts?.outOfStock[locale] || window.localizedTexts.outOfStock.default;
      const addToCartText = window.localizedTexts?.addToCart[locale] || window.localizedTexts.addToCart.default;
       console.log(variant__available);
      if (variant__available == 'false') {
        $(".product-hero__add-pro").addClass("disabled").text(outOfStockText);
        $(this).addClass("disabled");
      } else {
        $(".product-hero__add-pro").removeClass("disabled").text(addToCartText);
        $(this).removeClass("disabled");
      }

      $(".product-hero__guide-price span").text(variant_pirce);
    }
    return true;

  });
  if (!isMatchFound) {

    let variant_name = updateValue.trim().split(" / ");

    $(".product-hero__color-name em").each(function (index) {
      $(this).text(variant_name[index]);
    });
    // $(".product-hero__add-pro").addClass("disabled");




  }

}

$(".product-hero__color-item input[type='radio']").change(function () {
  matchVariant();
  selectedVarint();
})

$(document).ready(function () {
  matchVariant();
  
});




















$(".product-hero__add-pro").on("click", function (e) {

  e.preventDefault();
  formData = $(this).closest(".single__product-add-pro").serialize();
  addToCart(formData)
})




// });






// variant show and hide new code 


// $(".product-hero__others-item").on("click", function () {
//   const value = $(this).find("input").val().trim().toLowerCase();

//   $(".select__variant option").each(function () {
//     const optionValue = $(this).text().trim();
//     const optionValue_split = optionValue.split(" / ");

//     if (optionValue_split[0].trim().toLowerCase() === value) {
//       $(".product-hero__color-item-item").hide();

//       $(".product-hero__color-item-item").each(function () {
//         const inputValue = $(this).find("input").attr("data-materials");

//         if (inputValue) {
//           const materialsArray = inputValue.toLowerCase().split(",").map(m => m.trim());

//           if (materialsArray.includes(value)) {
//             $(this).show(); 

//           }
//         }
//       });
//     }
//   });
//  });


// $(".product-hero__others-item").on("click", function () {
//   const value = $(this).find("input").val().trim().toLowerCase();

//   $(".select__variant option").each(function () {
//     const optionValue = $(this).text().trim();
//     const optionValue_split = optionValue.split(" / ");

//     if (optionValue_split[0].trim().toLowerCase() === value) {
//       $(".product-hero__color-item-item").hide();

//       let foundFirst = false; // Track first match

//       $(".product-hero__color-item-item").each(function () {
//         const inputEl = $(this).find("input");
//         const inputValue = inputEl.attr("data-materials");

//         if (inputValue) {
//           const materialsArray = inputValue.toLowerCase().split(",").map(m => m.trim());

//           if (materialsArray.includes(value)) {
//             $(this).show();

//             // Uncheck all inputs first
//             $(".product-hero__color-item-item input[type='radio']").prop("checked", false);
//              $(this).find("input").prop("checked", true);

//           }
//         }
//       });
//     }
//   });
// });

$(".product-hero__others-item").on("click", function () {
  const value = $(this).find("input").val().trim().toLowerCase();

  $(".select__variant option").each(function () {
    const optionValue = $(this).text().trim();
    const optionValue_split = optionValue.split(" / ");

    if (optionValue_split[0].trim().toLowerCase() === value) {
      $(".product-hero__color-item-item").hide();

      // Uncheck all inputs first
      $(".product-hero__color-item-item input[type='radio']").prop("checked", false);

      // Track matching items
      const matchingItems = [];

      $(".product-hero__color-item-item").each(function () {
        const inputEl = $(this).find("input");
        const inputValue = inputEl.attr("data-materials");

        if (inputValue) {
          const materialsArray = inputValue.toLowerCase().split(",").map(m => m.trim());

          if (materialsArray.includes(value)) {
            $(this).show();
            matchingItems.push(this); // store matching elements
          }
        }
      });

      // Check the first matching visible input
      if (matchingItems.length > 0) {
        $(matchingItems[0]).find("input").prop("checked", true);
      }
    }
  });
});


// variant show and hide new code 









// new modify code 


function increment_p(el) {
  var input = el.previousElementSibling;
  var value = parseInt(input.value);
  value = isNaN(value) ? 0 : value
  value++;
  input.value = value;
  $(".product-hero__quantity-minus").addClass("active");

}

function decrement_p(el) {
  var input = el.nextElementSibling;
  var value = parseInt(input.value);
  if (value > 1) {
    value = isNaN(value) ? 1 : value;
    value--;
    input.value = value;

    if (value == 1) {
      $(".product-hero__quantity-minus").removeClass("active");
    }
  }
}



function addToCart(formData) {
  console.log(formData);
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: formData,
    success: function (data) {
      console.log(data)
      sectionRedering();
      //   $(".cart").addClass("active");
      $("body").addClass("cart-open");

    },
    error: function (err) {
      console.log(err);
    },
  });
}





// increment quantity in cart drawer
function increment(el) {
  var input = el.previousElementSibling;
  var value = parseInt(input.value);
  console.log(value)
  value = isNaN(value) ? 0 : value
  value++;
  input.value = value;
  changeQuantity(input);

}
// decrement quantity in cart drawer
function decrement(el) {
  var input = el.nextElementSibling;
  var value = parseInt(input.value);
  if (value > 0) {
    value = isNaN(value) ? 0 : value;
    value--;
    input.value = value;
    changeQuantity(input);
  }
}

function changeQuantity(input) {

  var quantity = $(input).val();
  var data_line = $(input).attr("data-line");
  var data = {
    "line": data_line,
    "quantity": quantity
  };
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: data,
    success: function (data) {
      console.log(data);
      sectionRedering();
    },
    error: function (err) {
      console.log("Error from quantity update")
    }
  })


}


function removeItem(event, el) {
  event.preventDefault();
  var data_line = $(el).attr("data-line");
  console.log(data_line)
  var deleteData = {
    "line": data_line,
    "quantity": 0
  };

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: deleteData,
    success: function (data) {

      sectionRedering();
    }
  })
}

matchVariant();

function addToCart_inCart(event, element) {
  event.preventDefault(); // Stop default action
  var variantId = $(element).attr('data-upsell-product'); // Use element
  var data = {
    id: variantId,
    quantity: 1
  };
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function (response) {
      sectionRedering();
    },
    error: function (err) {
      console.log("Error adding product to cart:", err);
    }
  });
}